module.exports = __webpack_public_path__ + "static/media/18.da5b3453.jpg";